import {CommonModule} from '@angular/common';
import {Component, Input} from '@angular/core';
import {TemaService} from '@app/service/tema.service';
import {TooltipModule} from 'primeng/tooltip';

@Component({
    selector: 'app-theme-toggle',
    imports: [CommonModule, TooltipModule],
    host: { '[class.is-floating]': 'floating' },
    template: `
        <button type="button" [class.theme-toggle--floating]="floating" (click)="alternar($event)"
                [attr.aria-label]="(floating ? 'Tema: ' : 'Apariencia: ') + accion"
                [pTooltip]="accion" [tooltipPosition]="floating ? 'left' : 'top'">
            <span class="pi" [ngClass]="tema.oscuro ? 'pi-sun' : 'pi-moon'" aria-hidden="true"></span>
            <span *ngIf="!floating">Apariencia</span>
            <span *ngIf="!floating" class="theme-toggle__current">{{tema.oscuro ? 'Oscuro' : 'Claro'}}</span>
        </button>
    `,
    styleUrls: ['./app.theme-toggle.component.scss']
})
export class AppThemeToggleComponent {
    @Input() floating = false;

    constructor(public readonly tema: TemaService) {}

    get accion(): string {
        return this.tema.oscuro ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro';
    }

    alternar(event: Event): void {
        event.stopPropagation();
        this.tema.alternar();
    }
}
